var req = require("!!/Users/admin/hogan/portfolio/node_modules/pug-loader/index.js!/Users/admin/hogan/portfolio/src/app/home-cheques/home-cheques.component.pug");
module.exports = (req['default'] || req).apply(req, [])